module.exports = __webpack_public_path__ + "img/omegaBlue.8becf1e5.png";